import { empytMaskValue } from '../constants/Forms';

export const unmaskPhone = (phone) => {
  return phone === empytMaskValue.phone || phone === null
    ? null
    : phone.replace(/\D/g, '');
};

export const unmaskPercent = (percent, beDecimal = false) => {
  const result = percent ? Number(percent?.replace('%', '')) : null;
  return beDecimal ? result.toString() : result;
};
